/** Allowed characters for the segment after `/{venue-name}/`. */
export const FAQ_SLUG_SUFFIX_RE = /^[a-z0-9][a-z0-9-]*$/

export function toHyphenatedSlug (text) {
  return String(text ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/^[^a-z0-9]+/, '')
}

/**
 * URL prefix for FAQ slugs from venue display name, e.g. `Madison Square Garden` → `/madison-square-garden/`
 */
export function getFaqSlugPrefix (venueName) {
  const segment = toHyphenatedSlug(venueName)
  if (!segment) return ''
  return `/${segment}/`
}

/**
 * Editable slug suffix: segment after `/{venue-name}/`.
 * Supports legacy `{venue-slug}-faq` slugs by returning the full slug when the prefix is not found.
 */
export function getFaqSlugSuffix (slug, venueName) {
  const normalized = String(slug ?? '')
    .replace(/^\/+/, '')
    .toLowerCase()
  const prefixSegment = toHyphenatedSlug(venueName)
  if (!prefixSegment) return normalized

  const marker = `${prefixSegment}/`
  const idx = normalized.indexOf(marker)
  if (idx === -1) return normalized

  return normalized.slice(idx + marker.length)
}

export function buildFaqSlugFromVenue (venueName, suffix = 'faqs') {
  const prefix = getFaqSlugPrefix(venueName)
  if (!prefix) return ''

  const normalizedSuffix = toHyphenatedSlug(suffix) || 'faqs'
  return `${prefix}${normalizedSuffix}`
}

/** Default slug suffix for venue concession pages, e.g. `/beacon-theatre/food-drink`. */
export const CONCESSION_SLUG_SUFFIX = 'food-drink'

export function buildConcessionSlugFromVenue (venueName) {
  return buildFaqSlugFromVenue(venueName, CONCESSION_SLUG_SUFFIX)
}

export function isValidConcessionSlug (slug, venueName) {
  return slug === buildConcessionSlugFromVenue(venueName)
}

export function isValidFaqSlug (slug, venueName) {
  const prefix = getFaqSlugPrefix(venueName)
  if (!prefix || !slug) return false

  const suffix = getFaqSlugSuffix(slug, venueName)
  if (!FAQ_SLUG_SUFFIX_RE.test(suffix)) return false

  const expectedPrefix = prefix.replace(/\/$/, '')
  return String(slug).toLowerCase().startsWith(expectedPrefix)
}
